<template>
  <div>
    <b-row>
      <h2>{{ $t("tracking.cargo.list") }}</h2>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <b-row>
      <b-col>
        <router-link :to="'/trackingShippingCompany/cargo/create'">
          <b-button size="sm">{{ $t("geral.create") }}</b-button>
        </router-link>
        <router-link :to="'./importExcel'" class="ml-2">
          <b-button size="sm">{{ $t("geral.importExcel") }}</b-button>
        </router-link>
      </b-col>
    </b-row>
    <!-- {{tableFilters}} -->
    <div v-if="isLoadingFilters">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <b-table
        ref="table"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <!-- {{field}} -->
              <div v-if="field.key == 'actions'" class="saveFilter">
                <b-col v-if="field.key == 'actions'">
                  <b-form-group
                    :label="$t('geral.saveFilters')"
                    label-for="saveFilter"
                    class="labelSaveFilter"
                  >
                    <b-form-checkbox
                      class="checkboxSaveFilter"
                      id="saveFilter"
                      v-model="tableFilters.saveFilter"
                    ></b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-button
                  size="sm"
                  class="btn-checklist cleanFilters"
                  @click="cleanFilters"
                >
                  {{ $t("geral.cleanFilters") }}
                </b-button>
              </div>
              <div v-if="tableFilters[field.key] != null">
                <multiselect
                  v-if="field.key == 'companyBranchId'"
                  v-model="tableFilters[field.key]"
                  class="companyBranch"
                  label="text"
                  track-by="value"
                  :close-on-select="false"
                  :showLabels="false"
                  :placeholder="'Buscar por filial'"
                  :options="optionsBranchName"
                  :multiple="true"
                ></multiselect>
                <b-form-select
                  v-else-if="field.key == 'statusDescription'"
                  class="statusStyle"
                  :options="optionsStatus"
                  v-model="tableFilters[field.key]"
                >
                </b-form-select>
                <base-filter-date
                  v-else-if="field.key == 'dateAttendance'"
                  ref="baseFilterDate"
                  :dateFill.sync="tableFilters.dateAttendanceBegin"
                  :dateBegin.sync="tableFilters.dateAttendanceBegin"
                  :dateEnd.sync="tableFilters.dateAttendanceEnd"
                  :filterName.sync="field.label"
                  :optionFilterDate.sync="tableFilters.optionFilterDate"
                  v-model="tableFilters[field.key]"
                ></base-filter-date>
                <b-form-select
                  v-else-if="field.filterKey == 'cargoActive'"
                  :options="optionsBooleanString"
                  v-model="tableFilters['cargoActive']"
                ></b-form-select>
                <b-form-input
                  v-else-if="field.key == 'dateDeliveryForecast'"
                  type="date"
                  v-model="tableFilters[field.key]"
                />
                <b-form-input
                  v-else
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(statusDescription)="data">
          <!-- {{data.item}} -->
          <label
            for="statusDescription"
            v-if="
              data.item.statusDescription == 'Procurando veiculo' &&
              data.item.willExpire != true
            "
            class="statusGreen"
            >{{ data.item.statusDescription }}</label
          >
          <label
            for="statusDescription"
            v-if="data.item.willExpire == true && data.item.status == 2"
            class="statusPink"
            >{{ data.item.statusDescription }}</label
          >
          <label
            for="statusDescription"
            v-if="data.item.statusDescription == 'Não atendido'"
            class="statusGrey"
            >{{ data.item.statusDescription }}</label
          >
          <label
            for="statusDescription"
            v-if="
              data.item.statusDescription != 'Procurando veiculo' &&
              data.item.statusDescription != 'Não atendido' &&
              data.item.statusDescription != 'Prioridade'
            "
            class="statusBlue"
            >{{ data.item.statusDescription }}</label
          >
        </template>
        <template v-slot:cell(actions)="data">
          <!-- Edit -->
          <router-link
            v-if="isCargoEditable(data.item)"
            class="desktop-buttons"
            :to="getUrlEdit(data.item)"
          >
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <router-link
            v-else
            class="desktop-buttons"
            :to="getUrlEdit(data.item)"
          >
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.detalhes") }}
            </b-button>
          </router-link>
          <router-link class="ml-2" :to="getUrlCargoExpenseId(data.item)">
            <b-button size="sm" class="pl-3 pr-3">
              {{ $t("geral.expenses") }}
            </b-button>
          </router-link>

          <b-button
            class="pl-3 pr-3"
            size="sm"
            style="margin-left: 8px"
            @click="openModal(data.item.cargoId)"
          >
            {{ $t(`geral.rotogram`) }}
          </b-button>
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </div>

    <cargo-rotogram ref="cargoRotogram" />

    <!-- <div>{{filter}}</div> -->
    <!-- <div>{{fields}}</div> -->
    <!-- <div>{{data.item}}</div> -->
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
export default {
  name: "FormSchedules",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps,
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    CargoRotogram: () =>
      import(
        "@/pagesRms/trackingShippingCompany/cargoRotogram/CargoRotogram.vue"
      ),
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      isLoadingFilters: true,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
        {
          key: "cargoId",
          filterKey: "cargoId",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "statusDescription",
          filterKey: "statusDescription",
          sortable: false,
          label: "Status",
          tdClass: "nowrap",
        },
        {
          key: "dateAttendance",
          filterKey: "dateAttendance",
          label: "Coleta",
          sortable: true,
          tdClass: "nowrap",
          formatter: (value, key, item) => {
            if (value == null) return "";
            let date = new Date(value);
            return date.toLocaleDateString();
          },
        },
        {
          key: "dateDeliveryForecast",
          filterKey: "dateDeliveryForecast",
          label: "Entrega",
          sortable: true,
          tdClass: "nowrap",
          formatter: (value, key, item) => {
            if (value == null) return "";
            let date = new Date(value);
            return date.toLocaleDateString();
          },
        },
        {
          key: "companyBranchId",
          filterKey: "companyBranchId",
          label: "filial",
          sortable: true,
          tdClass: "nowrap",
          formatter: (value, key, item) => {
            return item.companyBranchName;
          },
        },
        {
          key: "originCityName",
          filterKey: "originCityName",
          label: "Município origem",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "originStateAbrev",
          filterKey: "originStateAbrev",
          label: "UF origem",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "destinationCityName",
          filterKey: "destinationCityName",
          label: "Município destino",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "destinationStateAbrev",
          filterKey: "destinationStateAbrev",
          label: "UF destino",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "clientName",
          filterKey: "clientName",
          label: "Cliente",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "transportNumber",
          filterKey: "transportNumber",
          label: this.$t("tracking.cargo.transportNumber"),
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "driver",
          filterKey: "driver",
          label: this.$t("tracking.cargo.driver"),
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "vehiclePlate",
          filterKey: "vehiclePlate",
          label: this.$t("tracking.cargo.vehiclePlate"),
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "trailerPlate1",
          filterKey: "trailerPlate1",
          label: "Placa da 1º carreta",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "trailerPlate2",
          filterKey: "trailerPlate2",
          label: "Placa da 2º carreta",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "trailerPlate3",
          filterKey: "trailerPlate3",
          label: "Placa da 3º carreta",
          sortable: true,
          tdClass: "nowrap",
        },
        {
          key: "cargoActive",
          filterKey: "cargoActive",
          label: "Ativo",
          sortable: true,
          tdClass: "nowrap",
        },
        // {
        //   key: "cargoTypeId",
        //   filterKey: "cargoTypeId",
        //   sortable: false,
        //   label: this.$t("tracking.cargo.cargoType"),
        //   tdClass: "table-col-dinamic-width",
        //   formatter: (value, key, item) => {
        //     if (value == 2) return "Subcontrato";
        //     return "Contrato";
        //   },
        // },

        // {
        //   key: "dateAttendanceExpiration",
        //   filterKey: "dateAttendanceExpiration",
        //   label: "Data de expiração",
        //   sortable: true,
        //   formatter: (value, key, item) => {
        //     if (value == null) return "";
        //     let date = new Date(value);
        //     return date.toLocaleDateString();
        //   },
        // },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsBooleanString: [
        { value: "", text: "Todos" },
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
      optionsCargoType: [
        { value: "", text: "Todos" },
        { value: "1", text: "Contrato" },
        { value: "2", text: "Subcontrato" },
      ],
      bordered: true,
      companyBranchId: 0,
      optionsBranchName: [],
      optionsStatus: [
        { value: "", text: "Todos" },
        { value: "-1", text: "Prioritário" },
      ],
      tableFilters: {
        cargoId: "",
        statusDescription: "",
        cargoName: "",
        cargoDescription: "",
        clientName: "",
        companyBranchId: [],
        dateAttendanceBegin: "",
        dateAttendanceEnd: "",
        dateAttendance: "",
        dateDeliveryForecast: "",
        originCityName: "",
        originStateAbrev: "",
        destinationCityName: "",
        destinationStateAbrev: "",
        cargoActive: "true",
        transportNumber: "",
        deliveryDate: "",
        driver: "",
        vehiclePlate: "",
        trailerPlate1: "",
        trailerPlate2: "",
        trailerPlate3: "",
        optionFilterDate: 0,
        saveFilter: true,
      },
      // saveFilter: true,
      branchNameId: 1,
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created() {
    this.getFilterApplied();
    this.loadBranchName();
    this.loadOccurrencies();
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
    getLoadDataUrl() {
      return `/empresa/all`;
    },
  },
  methods: {
    openModal(cargoId) {
      this.$refs.cargoRotogram.show(cargoId);
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    getUrlEdit(cargo) {
      return `/trackingShippingCompany/cargo/edit/${cargo.cargoId}`;
    },
    getUrlFilledDetails(cargo) {
      return "/trackingShippingCompany/cargo/details/" + cargo.checklistId;
    },
    getUrlCargoExpenseId(cargo) {
      return `/trackingShippingCompany/cargoExpense/list/${cargo.cargoId}`;
    },
    isCargoActive(cargo) {
      if (cargo) {
        return cargo.cargoActive;
      }
      return false;
    },
    isCargoEditable(cargo) {
      if (!this.isCargoActive(cargo)) {
        return false;
      }
      if (!cargo) {
        return false;
      }
      if (cargo.isInUse) {
        return false;
      }
      return true;
    },
    myProvider(ctx) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        this.tableRowCount = 0;
        return [];
      }

      this.isBusy = true;
      this.tableFilters.dateAttendance == this.tableFilters.dateAttendanceBegin;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        cargoId: ctx.filter.cargoId,
        clientName: ctx.filter.clientName,
        dateAttendanceBegin: ctx.filter.dateAttendanceBegin,
        dateAttendanceEnd: ctx.filter.dateAttendanceEnd,
        dateDeliveryForecastBegin: ctx.filter.dateDeliveryForecast,
        dateDeliveryForecastEnd: ctx.filter.dateDeliveryForecast,
        originCityName: ctx.filter.originCityName,
        originStateAbrev: ctx.filter.originStateAbrev,
        destinationCityName: ctx.filter.destinationCityName,
        destinationStateAbrev: ctx.filter.destinationStateAbrev,
        transportNumber: ctx.filter.transportNumber,
        companyBranchId: ctx.filter.companyBranchId,
        driver: ctx.filter.driver,
        deliveryDateBegin: ctx.filter.deliveryDate,
        deliveDateEnd: ctx.filter.deliveryDate,
        vehiclePlate: ctx.filter.vehiclePlate,
        trailerPlate1: ctx.filter.trailerPlate1,
        trailerPlate2: ctx.filter.trailerPlate2,
        trailerPlate3: ctx.filter.trailerPlate3,
        status: ctx.filter.statusDescription,
        cargoActive: ctx.filter.cargoActive,
      };
      return this.$api
        .post("/cargo/all", apiParam)
        .then((response) => {
          const items = response.data.items;
          items.forEach((item) => {
            if (item.cargoActive == true) item.cargoActive = "Sim";
            else item.cargoActive = "Não";
          });
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          this.postFilterApplied(this.tableFilters);
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            console.log(error);
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    async postFilterApplied(filter) {
      // console.log(filter)
      let filters = {
        appliedFilters: JSON.stringify(filter),
        saveFilter: this.tableFilters.saveFilter,
      };
      this.$api
        .post("/cargo/filtersAppliedCargas", filters)
        .then((response) => {
          this.tableFilters = JSON.parse(response.data.appliedFilters);
          this.tableFilters.dateAttendance ==
            this.tableFilters.dateAttendanceBegin;
          this.tableFilters.saveFilter = response.data.saveFilter;
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    async getFilterApplied() {
      // console.log("GetFilters");
      this.$api
        .get("/cargo/filtersCargas")
        .then((response) => {
          if (response.data) {
            if (response.data.appliedFilters != null) {
              let model = JSON.parse(response.data.appliedFilters);
              // console.log(response);
              this.tableFilters = model;
              this.tableFilters.saveFilter = response.data.saveFilter;
              this.tableFilters.dateAttendance ==
                this.tableFilters.dateAttendanceBegin;
              this.isLoadingFilters = false;
              this.$forceUpdate();
            } else {
              this.isLoadingFilters = false;
              this.$forceUpdate();
            }
          } else {
            this.isLoadingFilters = false;
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          if (error.response) {
            if (error.data) {
              console.log(error.response.data.errors);
            }
          }
          this.isLoadingFilters = false;
          this.$forceUpdate();
        });
    },
    loadBranchName() {
      let apiParam = {
        currentPage: 1,
        perPage: 9999,
      };
      this.$api
        .post(this.getLoadDataUrl, apiParam)
        .then((response) => {
          let companies = response.data.items;
          for (let company of companies) {
            this.optionsBranchName.push({
              value: company.id,
              text: company.branchName,
            });
          }
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    loadOccurrencies() {
      this.$api
        .get("/v1/occurrenceType/dropdownOptions")
        .then((response) => {
          let occurrences = response.data;
          for (let occurrence of occurrences) {
            this.optionsStatus.push({
              value: occurrence.value,
              text: occurrence.text,
            });
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    cleanFilters() {
      this.tableFilters.cargoId = "";
      this.tableFilters.statusDescription = "";
      this.tableFilters.cargoName = "";
      this.tableFilters.cargoDescription = "";
      this.tableFilters.clientName = "";
      this.tableFilters.companyBranchId = [];
      this.tableFilters.dateAttendance = "";
      this.tableFilters.dateAttendanceBegin = "";
      this.tableFilters.dateAttendanceEnd = "";
      this.tableFilters.dateDeliveryForecast = "";
      this.tableFilters.originCityName = "";
      this.tableFilters.originStateAbrev = "";
      this.tableFilters.destinationCityName = "";
      this.tableFilters.destinationStateAbrev = "";
      this.tableFilters.transportNumber = "";
      this.tableFilters.deliveryDate = "";
      this.tableFilters.driver = "";
      this.tableFilters.vehiclePlate = "";
      this.tableFilters.trailerPlate1 = "";
      this.tableFilters.trailerPlate2 = "";
      this.tableFilters.trailerPlate3 = "";
      this.tableFilters.optionFilterDate = 0;
      this.tableFilters.cargoActive = "true";
      this.tableFilters.saveFilter = true;
      this.postFilterApplied(this.tableFilters);
    },
  },
};
</script>

<style scoped>
.btn-checklist {
  min-width: 95px;
}
.right {
  text-align: right;
  width: 100%;
}
.btn-tag {
  font-size: 0.875rem;
}
.form-control-tag {
  border: none;
}
.kanban-modal {
  z-index: 1060;
}
.search-icon {
  background: #2c3b5d;
  width: 3rem;
  height: 100%;
  padding-top: 8px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.companyBranch {
  min-width: 200px;
}
.vertical-align {
  vertical-align: bottom !important;
}
.checkboxSaveFilter {
  margin-left: 105px;
  margin-top: -28px;
}
.labelSaveFilter {
  margin-left: -15px;
}
.statusGreen {
  background-color: rgb(0, 206, 122);
  padding: 5px 10px 5px 10px;
  border-radius: 15px;
  margin-bottom: 0px;
}
.statusPink {
  background-color: rgb(238, 153, 162);
  padding: 5px 10px 5px 10px;
  border-radius: 15px;
  margin-bottom: 0px;
}
.statusGrey {
  background-color: #a8a8a8;
  padding: 5px 10px 5px 10px;
  border-radius: 15px;
  margin-bottom: 0px;
}
.statusBlue {
  background-color: rgb(0, 185, 251);
  padding: 5px 10px 5px 10px;
  border-radius: 15px;
  margin-bottom: 0px;
}
.statusStyle {
  min-width: 150px;
}
.idStyle {
  min-width: 80px;
}
.saveFilter {
  min-width: 150px;
}
</style>